var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerMovil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 604,
    viewBox: "0 0 374 604",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 604,
    fill: "#E6FAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9061_11801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.877 534.83H7.37695V641.271H47.877V534.83Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8864 534.83H27.6318V641.271H47.8864V534.83Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3047 522.172H12.001V534.829H26.3047V522.172Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.304 522.172H22.8906V534.829H26.304V522.172Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0602 534.086H4V534.82H49.0602V534.086Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8006 540.341H15.3691V547.603H18.8006V540.341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6322 550.451C27.6322 550.524 23.0991 550.587 17.5095 550.587C11.9198 550.587 7.38672 550.524 7.38672 550.451C7.38672 550.379 11.9198 550.315 17.5095 550.315C23.0991 550.315 27.6322 550.379 27.6322 550.451Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2264 540.341H35.7949V547.603H39.2264V540.341Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.058 550.45C48.058 550.523 43.5249 550.586 37.9352 550.586C32.3456 550.586 27.8125 550.523 27.8125 550.45C27.8125 550.378 32.3456 550.314 37.9352 550.314C43.5249 550.314 48.058 550.378 48.058 550.45Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2264 554.756H35.7949V562.018H39.2264V554.756Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.058 564.865C48.058 564.938 43.5249 565.001 37.9352 565.001C32.3456 565.001 27.8125 564.938 27.8125 564.865C27.8125 564.792 32.3456 564.729 37.9352 564.729C43.5249 564.729 48.058 564.792 48.058 564.865Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2264 569.599H35.7949V576.861H39.2264V569.599Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.058 579.708C48.058 579.781 43.5249 579.844 37.9352 579.844C32.3456 579.844 27.8125 579.781 27.8125 579.708C27.8125 579.636 32.3456 579.572 37.9352 579.572C43.5249 579.572 48.058 579.636 48.058 579.708Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2274 584.449H35.7959V591.711H39.2274V584.449Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.058 594.547C48.058 594.62 43.5249 594.683 37.9352 594.683C32.3456 594.683 27.8125 594.62 27.8125 594.547C27.8125 594.475 32.3456 594.411 37.9352 594.411C43.5249 594.411 48.058 594.475 48.058 594.547Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2264 598.866H35.7949V606.128H39.2264V598.866Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8006 554.976H15.3691V562.238H18.8006V554.976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6322 565.084C27.6322 565.156 23.0991 565.22 17.5095 565.22C11.9198 565.22 7.38672 565.156 7.38672 565.084C7.38672 565.011 11.9198 564.948 17.5095 564.948C23.0991 564.948 27.6322 565.011 27.6322 565.084Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8006 569.608H15.3691V576.871H18.8006V569.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6322 579.708C27.6322 579.78 23.0991 579.844 17.5095 579.844C11.9198 579.844 7.38672 579.78 7.38672 579.708C7.38672 579.635 11.9198 579.572 17.5095 579.572C23.0991 579.572 27.6322 579.635 27.6322 579.708Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8006 584.233H15.3691V591.496H18.8006V584.233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6322 594.343C27.6322 594.415 23.0991 594.479 17.5095 594.479C11.9198 594.479 7.38672 594.415 7.38672 594.343C7.38672 594.27 11.9198 594.207 17.5095 594.207C23.0991 594.207 27.6322 594.27 27.6322 594.343Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8006 598.866H15.3691V606.128H18.8006V598.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.426 481.847H317.488V653.476H371.426V481.847Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.426 481.847H344.457V652.999H371.426V481.847Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.689 465H323.646V481.847H342.689V465Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.697 465H338.155V481.847H342.697V465Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.99 481.846V480.865H373V481.846",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.694 489.199H328.131V498.867H332.694V489.199Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.457 502.656C344.457 502.757 338.421 502.843 330.976 502.843C323.532 502.843 317.488 502.764 317.488 502.656C317.488 502.548 323.524 502.468 330.976 502.468C338.428 502.468 344.457 502.548 344.457 502.656Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.9 489.199H355.337V498.867H359.9V489.199Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.656 502.656C371.656 502.757 365.62 502.843 358.175 502.843C350.731 502.843 344.688 502.764 344.688 502.656C344.688 502.548 350.724 502.468 358.175 502.468C365.627 502.468 371.656 502.548 371.656 502.656Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.9 508.391H355.337V518.059H359.9V508.391Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.656 521.847C371.656 521.948 365.62 522.035 358.175 522.035C350.731 522.035 344.688 521.955 344.688 521.847C344.688 521.739 350.724 521.66 358.175 521.66C365.627 521.66 371.656 521.739 371.656 521.847Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.9 528.158H355.337V537.826H359.9V528.158Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.656 541.613C371.656 541.714 365.62 541.801 358.175 541.801C350.731 541.801 344.688 541.722 344.688 541.613C344.688 541.505 350.724 541.426 358.175 541.426C365.627 541.426 371.656 541.505 371.656 541.613Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.9 547.928H355.337V557.596H359.9V547.928Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.656 561.384C371.656 561.485 365.62 561.572 358.175 561.572C350.731 561.572 344.688 561.493 344.688 561.384C344.688 561.276 350.724 561.197 358.175 561.197C365.627 561.197 371.656 561.276 371.656 561.384Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.9 567.128H355.337V576.796H359.9V567.128Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.656 580.591C371.656 580.692 365.62 580.779 358.175 580.779C350.731 580.779 344.688 580.699 344.688 580.591C344.688 580.483 350.724 580.403 358.175 580.403C365.627 580.403 371.656 580.483 371.656 580.591Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.9 586.415H355.337V596.083H359.9V586.415Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.656 599.871C371.656 599.972 365.62 600.058 358.175 600.058C350.731 600.058 344.688 599.979 344.688 599.871C344.688 599.762 350.724 599.683 358.175 599.683C365.627 599.683 371.656 599.762 371.656 599.871Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.694 508.68H328.131V518.348H332.694V508.68Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.457 522.141C344.457 522.242 338.421 522.329 330.976 522.329C323.532 522.329 317.488 522.249 317.488 522.141C317.488 522.033 323.524 521.954 330.976 521.954C338.428 521.954 344.457 522.033 344.457 522.141Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.694 528.167H328.131V537.835H332.694V528.167Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.457 541.622C344.457 541.723 338.421 541.809 330.976 541.809C323.532 541.809 317.488 541.73 317.488 541.622C317.488 541.513 323.524 541.434 330.976 541.434C338.428 541.434 344.457 541.513 344.457 541.622Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.694 547.647H328.131V557.315H332.694V547.647Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.457 561.103C344.457 561.204 338.421 561.291 330.976 561.291C323.532 561.291 317.488 561.211 317.488 561.103C317.488 560.995 323.524 560.916 330.976 560.916C338.428 560.916 344.457 560.995 344.457 561.103Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.694 567.127H328.131V576.795H332.694V567.127Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.457 580.591C344.457 580.692 338.421 580.779 330.976 580.779C323.532 580.779 317.488 580.7 317.488 580.591C317.488 580.483 323.524 580.404 330.976 580.404C338.428 580.404 344.457 580.483 344.457 580.591Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.694 586.615H328.131V596.283H332.694V586.615Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.457 600.071C344.457 600.172 338.421 600.259 330.976 600.259C323.532 600.259 317.488 600.18 317.488 600.071C317.488 599.963 323.524 599.884 330.976 599.884C338.428 599.884 344.457 599.963 344.457 600.071Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.639 565.133H54.3232V701.026H125.639V565.133Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.639 565.133H92.2031V701.026H125.639V565.133Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6917 577.923H69.2803V593.567H75.6917V577.923Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2036 599.701C92.2036 599.835 83.7204 599.947 73.2634 599.947C62.8064 599.947 54.3232 599.835 54.3232 599.701C54.3232 599.568 62.7994 599.455 73.2634 599.455C83.7274 599.455 92.2036 599.568 92.2036 599.701Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.711 577.921H99.2998V593.565H105.711V577.921Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.626 577.921H113.215V593.565H119.626V577.921Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 561.842H48.9609V565.251H131V561.842Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.136 565.574C126.136 565.707 110.198 565.82 90.5371 565.82C70.8759 565.82 54.9385 565.707 54.9385 565.574C54.9385 565.44 70.8759 565.328 90.5371 565.328C110.198 565.328 126.136 565.44 126.136 565.574Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.332 668.972H248.963L248.611 543.035H327.98L328.332 668.972Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.979 543.035H288.299V668.979H327.979V543.035Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.705 518.238H257.68V543.028H285.705V518.238Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.704 518.238H279.021V543.028H285.704V518.238Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.308 541.586H242V543.029H330.308V541.586Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.002 553.843H264.283V568.063H271.002V553.843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.299 573.648C288.299 573.8 279.417 573.922 268.458 573.922C257.5 573.922 248.618 573.8 248.618 573.648C248.618 573.497 257.5 573.374 268.458 573.374C279.417 573.374 288.299 573.497 288.299 573.648Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.028 553.843H304.31V568.063H311.028V553.843Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.324 573.649C328.324 573.801 319.442 573.923 308.484 573.923C297.525 573.923 288.644 573.801 288.644 573.649C288.644 573.498 297.525 573.375 308.484 573.375C319.442 573.375 328.324 573.498 328.324 573.649Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.028 582.083H304.31V596.303H311.028V582.083Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.324 601.888C328.324 602.039 319.442 602.162 308.484 602.162C297.525 602.162 288.644 602.039 288.644 601.888C288.644 601.736 297.525 601.614 308.484 601.614C319.442 601.614 328.324 601.736 328.324 601.888Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.002 582.516H264.283V596.736H271.002V582.516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.299 602.321C288.299 602.473 279.417 602.595 268.458 602.595C257.5 602.595 248.618 602.473 248.618 602.321C248.618 602.17 257.5 602.047 268.458 602.047C279.417 602.047 288.299 602.17 288.299 602.321Z",
    fill: "#E0E0E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9061_11801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 369,
    height: 139,
    fill: "white",
    transform: "translate(4 465)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerMovil);
export default __webpack_public_path__ + "static/media/bannerMovil.9e2a56d9844bf1f574b25a9d70b78459.svg";
export { ForwardRef as ReactComponent };